import { TokenLogo } from "./TokenSelect";
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errMsg } from "../lib/api";
import { fmtUsd } from "../lib/format";
import { Loading, ErrorState, Empty } from "./State";

export const PairSearch = ({ open, onOpenChange, onSelect }) => {
  const [q, setQ] = useState("");
  const [state, setState] = useState({ loading: false, pools: [], error: null });

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      setState((s) => ({ ...s, loading: true, error: null }));
      const req = q.trim() ? api.get("/market/search", { params: { q: q.trim() } }) : api.get("/market/top-pools", { params: { dex: "uniswap-v3-robinhood" } });
      req.then((r) => setState({ loading: false, pools: r.data.pools, error: null }))
        .catch((e) => setState({ loading: false, pools: [], error: errMsg(e) }));
    }, 350);
    return () => clearTimeout(t);
  }, [q, open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#12161F] border-lime/20 max-w-xl text-slate-100" data-testid="pair-search-dialog">
        <DialogHeader><DialogTitle className="font-display tracking-wide">Search Robinhood Chain pairs</DialogTitle></DialogHeader>
        <input data-testid="pair-search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Symbol, name or pool / token address"
          className="field" />
        <div className="max-h-[420px] overflow-y-auto -mx-2">
          {state.loading ? <Loading /> : state.error ? <ErrorState message={state.error} /> : !state.pools.length ? <Empty title="No pools found" /> :
            state.pools.map((p) => (
              <button key={p.address} data-testid={`pair-option-${p.address}`} onClick={() => onSelect(p)}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-lime/5 text-left">
                <TokenLogo t={p.base_token} size={28} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold truncate">{p.name}</p>
                  <p className="text-[11px] font-mono text-slate-500 truncate">{p.dex} · {p.address.slice(0, 14)}…</p>
                </div>
                <div className="text-right text-[11px] font-mono">
                  <p className="text-slate-200">{fmtUsd(p.price_usd, false)}</p>
                  <p className="text-slate-500">liq {fmtUsd(p.liquidity_usd)}</p>
                </div>
              </button>
            ))}
        </div>
        <p className="text-[10px] text-slate-500">Results are indexed pools, not endorsements. HIVEVORA swaps route across Uniswap v2, v3 and v4 pools via the Uniswap Trading API.</p>
      </DialogContent>
    </Dialog>
  );
};
